//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchUpdate } from '@/api/PMS/repair/autoAudit';
export default {
  data: function data() {
    return {
      data: {
        isSwitchAudit: 0,
        opDate: null,
        opName: null
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      fetchList({}).then(function (response) {
        _this.data = response.data.data;
      });
    },
    changeAudit: function changeAudit(val) {
      var _this2 = this;

      fetchUpdate({
        isSwitchAudit: val
      }).then(function (res) {
        if (res.data.code === 200) {
          _this2.Alert({
            alertType: 'update'
          });

          _this2.getList();
        }
      });
    }
  }
};